import { EAgencyActions } from './enums';
import { getAgency } from './services';

export const getAgencyAction = () => ({
    type: EAgencyActions.GET_AGENCY,
    payload: getAgency()
});
